import { apiRequest } from './api';

const API_PREFIX = '/vehicle-maintenance';

export const vehicleMaintenanceApi = {
  getVehicles: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.city) queryParams.append('city', params.city);
    if (params.hotel_id) queryParams.append('hotel_id', params.hotel_id);
    if (params.location) queryParams.append('location', params.location);
    if (params.brand) queryParams.append('brand', params.brand);
    if (params.fuel_type) queryParams.append('fuel_type', params.fuel_type);
    if (params.transport_type) queryParams.append('transport_type', params.transport_type);
    if (params.is_active !== undefined && params.is_active !== '') {
      queryParams.append('is_active', params.is_active);
    }
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/vehicles/${query}`);
  },

  getVehicle: async (id) => apiRequest(`${API_PREFIX}/vehicles/${id}/`),

  createVehicle: async (data) =>
    apiRequest(`${API_PREFIX}/vehicles/`, {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),

  updateVehicle: async (id, data) =>
    apiRequest(`${API_PREFIX}/vehicles/${id}/`, {
      method: data instanceof FormData ? 'PATCH' : 'PUT',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),

  deleteVehicle: async (id) =>
    apiRequest(`${API_PREFIX}/vehicles/${id}/`, { method: 'DELETE' }),

  getVehicleFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/vehicles/filter-options/`),

  getVehicleDashboardStats: async () =>
    apiRequest(`${API_PREFIX}/vehicles/dashboard-stats/`),

  bulkDeactivateVehicles: async (ids) =>
    apiRequest(`${API_PREFIX}/vehicles/bulk-deactivate/`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    }),

  getAuditLogs: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.table_name) queryParams.append('table_name', params.table_name);
    if (params.record_id) queryParams.append('record_id', params.record_id);
    if (params.action) queryParams.append('action', params.action);
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/audit-logs/${query}`);
  },

  getModuleAccessUsers: async () => apiRequest(`${API_PREFIX}/module-access/`),

  updateModuleAccessUsers: async (userIds, emailUserIds) =>
    apiRequest(`${API_PREFIX}/module-access/`, {
      method: 'PUT',
      body: JSON.stringify(
        emailUserIds === undefined
          ? { user_ids: userIds }
          : { user_ids: userIds, email_user_ids: emailUserIds },
      ),
    }),

  getInspections: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/inspections/${query}`);
  },
  createInspection: async (data) =>
    apiRequest(`${API_PREFIX}/inspections/`, { method: 'POST', body: JSON.stringify(data) }),
  updateInspection: async (id, data) =>
    apiRequest(`${API_PREFIX}/inspections/${id}/`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteInspection: async (id) =>
    apiRequest(`${API_PREFIX}/inspections/${id}/`, { method: 'DELETE' }),
  getInspectionFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/inspections/filter-options/`),

  getInsurances: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/insurances/${query}`);
  },
  createInsurance: async (data) =>
    apiRequest(`${API_PREFIX}/insurances/`, { method: 'POST', body: JSON.stringify(data) }),
  updateInsurance: async (id, data) =>
    apiRequest(`${API_PREFIX}/insurances/${id}/`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteInsurance: async (id) =>
    apiRequest(`${API_PREFIX}/insurances/${id}/`, { method: 'DELETE' }),
  getInsuranceFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/insurances/filter-options/`),

  getMaintenances: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/maintenances/${query}`);
  },
  createMaintenance: async (data) =>
    apiRequest(`${API_PREFIX}/maintenances/`, { method: 'POST', body: JSON.stringify(data) }),
  updateMaintenance: async (id, data) =>
    apiRequest(`${API_PREFIX}/maintenances/${id}/`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteMaintenance: async (id) =>
    apiRequest(`${API_PREFIX}/maintenances/${id}/`, { method: 'DELETE' }),
  getMaintenanceFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/maintenances/filter-options/`),

  getMileageLogs: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/mileage-logs/${query}`);
  },
  createMileageLog: async (data) =>
    apiRequest(`${API_PREFIX}/mileage-logs/`, { method: 'POST', body: JSON.stringify(data) }),
  updateMileageLog: async (id, data) =>
    apiRequest(`${API_PREFIX}/mileage-logs/${id}/`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteMileageLog: async (id) =>
    apiRequest(`${API_PREFIX}/mileage-logs/${id}/`, { method: 'DELETE' }),
  getMileageFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/mileage-logs/filter-options/`),

  getTrafficFines: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    if (params.user_notified !== undefined && params.user_notified !== '') {
      queryParams.append('user_notified', params.user_notified);
    }
    if (params.collected !== undefined && params.collected !== '') {
      queryParams.append('collected', params.collected);
    }
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/traffic-fines/${query}`);
  },
  createTrafficFine: async (data) =>
    apiRequest(`${API_PREFIX}/traffic-fines/`, { method: 'POST', body: JSON.stringify(data) }),
  updateTrafficFine: async (id, data) =>
    apiRequest(`${API_PREFIX}/traffic-fines/${id}/`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteTrafficFine: async (id) =>
    apiRequest(`${API_PREFIX}/traffic-fines/${id}/`, { method: 'DELETE' }),
  getTrafficFineFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/traffic-fines/filter-options/`),

  getBreakdowns: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    if (params.completion_status) queryParams.append('completion_status', params.completion_status);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/breakdowns/${query}`);
  },
  createBreakdown: async (data) =>
    apiRequest(`${API_PREFIX}/breakdowns/`, {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  updateBreakdown: async (id, data) =>
    apiRequest(`${API_PREFIX}/breakdowns/${id}/`, {
      method: data instanceof FormData ? 'PATCH' : 'PUT',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  deleteBreakdown: async (id) =>
    apiRequest(`${API_PREFIX}/breakdowns/${id}/`, { method: 'DELETE' }),
  getBreakdownFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/breakdowns/filter-options/`),

  getAccidents: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.vehicle_id) queryParams.append('vehicle_id', params.vehicle_id);
    if (params.insurance_file_status) queryParams.append('insurance_file_status', params.insurance_file_status);
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest(`${API_PREFIX}/accidents/${query}`);
  },
  createAccident: async (data) =>
    apiRequest(`${API_PREFIX}/accidents/`, {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  updateAccident: async (id, data) =>
    apiRequest(`${API_PREFIX}/accidents/${id}/`, {
      method: data instanceof FormData ? 'PATCH' : 'PUT',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  deleteAccident: async (id) =>
    apiRequest(`${API_PREFIX}/accidents/${id}/`, { method: 'DELETE' }),
  getAccidentFilterOptions: async () =>
    apiRequest(`${API_PREFIX}/accidents/filter-options/`),
};

export default vehicleMaintenanceApi;
